import { I18n } from "@assets/strings";
import React from "react";
import { useFollowers } from "@domain/user/hooks";
import { ProfileListModal } from "@ui/components/profile/profileListModal";

interface FollowersModalProps extends React.HTMLAttributes<HTMLDivElement> {
	profileId: string;
	close: () => void;
}
export const FollowersModal: React.FC<FollowersModalProps> = ({ profileId, ...props }) => {
	const data = useFollowers(profileId);

	return (
		<ProfileListModal
			title={I18n.t("profile.followers.title", { count: data.totalElements ?? 0 })}
			emptyMessage={I18n.t("profile.followers.empty")}
			data={data}
			{...props}
		/>
	);
};
